import Button from '@/components/ui/Button';
import { useOutsideClick } from "@/hooks/useOutsideClick";
import { AnimatePresence, motion } from "framer-motion";
import Image from 'next/image';
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import 'react-toastify/dist/ReactToastify.css';

const FailedfullInvite = ({
    isOpen,
    onClose,
    onTryAnother,
    error
}: {

    error?: string | null,
    baseApi?: string,
    onTryAnother?: () => void;
    isOpen: boolean;
    code?: string
    onClose: () => void;
}) => {
    const ref = useOutsideClick(() => onClose());

    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
        if (typeof window !== 'undefined' && document) {
            setIsReady(true)
        }
    }, [])

    if (!isReady) {
        return null;
    }

    return isOpen && isReady && createPortal(
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div className="fixed bottom-0 left-0 right-0 top-0 z-[100] before:absolute before:right-0 before:top-0 before:z-10 before:h-full before:w-full before:bg-gray-700/50">
                        {" "}
                    </motion.div>
                    <motion.div
                        ref={ref}
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
                        exit={{ y: 50, opacity: 0 }}
                        transition={{
                            duration: 0.3,
                            type: "inertia",
                        }}
                        className="fixed bottom-0 left-0 right-0 top-0 z-[110] m-auto w-11/12 h-fit max-h-dvh md:h-fit
             max-w-[510px]  p-4 items-start  rounded-xl md:rounded-2xl py-4 bg-white  overflow-y-auto"
                    >

                        <div className='flex md:flex-row flex-col items-center md:items-start gap-2 md:gap-6 justify-center w-full'>


                            <Image
                                className='max-w-32'
                                width={600}
                                height={400}
                                alt=''
                                src={`${process.env.NEXT_PUBLIC_STORAGE_URL}avatar/5439ea2c-001a-4fd6-b033-6d94fb243450-planingo.png`}
                            />
                            <div className='max-w-[250px] flex flex-col md:items-start items-center'>

                                <p className='text-sm md:text-base font-semibold text-neutral-900  mb-2'>Oops! That Code Didn’t Work!</p>
                                <p className='text-xs md:text-sm text-neutral-500 font-normal  max-w-xs'>The referral code  couldn’t be applied.</p>
                                {error && <p className='text-xs mt-2 md:text-sm text-red-600 
                                font-normal  max-w-xs'>{error}</p>
                                }

                            </div>
                        </div>
                        <div className='flex justify-center md:justify-end mt-4 md:mt-2'>
                            <Button onClick={() => {
                                onClose()
                                if (onTryAnother) {
                                    onTryAnother()
                                }
                            }} color='secondary'>
                                Try Another Code
                            </Button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>,
        window.document.body,
    );
};
export default FailedfullInvite;
